export const parseReply = (response: any) => {
  if (
    !response ||
    !Array.isArray(response.data) ||
    response.data.length === 0 ||
    !response.data[0] ||
    !Array.isArray(response.data[0].content) ||
    response.data[0].content.length === 0 ||
    !response.data[0].content[0] ||
    typeof response.data[0].content[0].text !== "string"
  ) {
    // Return null or a default value if the structure is unexpected
    return null;
  }
  const reply = response.data[0].content[0].text;
  return reply;
};
